// extracted by mini-css-extract-plugin
export var disabled = "_f-5";
export var error = "_f-1";
export var fitContent = "_f-6";
export var hasSuffix = "_f-4";
export var iconWrapper = "_f-b";
export var infoIconWrapper = "_f-d _f-b";
export var input = "_f-a";
export var inputWrapper = "_f-0";
export var large = "_f-8";
export var leadingIconWrapper = "_f-c _f-b";
export var measureBox = "_f-e";
export var medium = "_f-7";
export var readonly = "_f-2";
export var small = "_f-3";
export var suffix = "_f-9";